export default {
  setJoinMeetingTemp(state, joinMeetingTemp) {
    state.joinMeetingTemp = joinMeetingTemp
  }
}
